import {DomainEvent} from "@platform/event-bus/domain/model/domain-event.model";

/**
 * Waiter Sign Out Event
 * This event is published when a waiter needs to be signed out from the system.
 *
 * This event is typically triggered when:
 * - A booking is closed on a non-personal device
 * - Manual waiter sign out is requested
 * - System-initiated sign out is required
 */
export class WaiterSignOutEvent implements DomainEvent {
  readonly occurredAt = new Date();
  readonly eventType = 'WaiterSignOutEvent';
}
